<script>
    import Layout from "../../../../layouts/main";
    import PageHeader from "@/components/page-header";
import SelectWithSearch from "../../Common/SelectWithSearch.vue";
import { RAW_MATERIAL_PATH, RG_RECIPE_PATH } from "@/path";
import axios from "axios";
import Swal from "sweetalert2";
    // import BEditableTable from 'bootstrap-vue-editable-table';

    export default {
        components : {
    Layout,
    PageHeader,
    SelectWithSearch
},
        data(){
            return {
                title: "Add Recipe Card",
                items: [
                    {
                        text: "Create / Edit",
                    },
                    {
                        text: "Management",
                        active: true,
                    },
                ],                
                form : {
                    status : 'testing'
                },
                no_of_batches : 1,
                fields: ['name','indent','uom'],  
                data : [],
                cdn : process.env.VUE_APP_AWS_CDN,
                base_url : process.env.VUE_APP_API_BACKEND_URL,
                version : 1,
                selectedRecipeId : null,   
                isEdit : false,    
                key : 1,  
                selectedRecipe : null,
                description : '',
                total_weight : 0          
            }
        },
        computed : {
            RAW_MATERIAL_PATH(){
                return RAW_MATERIAL_PATH
            },
            RG_RECIPE_PATH(){
                return RG_RECIPE_PATH
            }
        },
        watch :{
            data : {
                deep : true,
                handler(){
                    this.key += 1;
                }
            },
            no_of_batches(){                
                this.totalWeight();
                this.key += 1;
            }
        },
        methods: {
            downloadInvoiceFile(file){
                const link = document.createElement('a');
                link.href = this.cdn + '/' + file;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            setRawMaterial(e,v){
                this.data[v.index].item_id = e.id;
                this.data[v.index].unit_price = e.price_data ? e.price_data.unit_price : 0;
            },
            addData(type){
                this.data.push({
                    type : type,
                    item_id : null,
                    _rowVariant : type == 'raw_material' ? 'default' : 'primary',
                });
            },
            deleteRow(v){
                this.data.splice(v.index,1);
            },
            setTotal(row,field){
                if(field == 'total'){
                    this.data[row.index].total = row.item.indent * row.item.unit_price;
                }else{
                    this.data[row.index].unit_price = row.item.indent / row.item.total;
                }
            },
            async getData(){
                try {
                    let res = await axios.get(this.base_url + RG_RECIPE_PATH.SHOW,{
                        params : {
                            id : this.selectedRecipeId
                        }
                    });
                    if(res.data.status){
                        let d = res.data.data;                        
                        this.form = {
                            recipe_name : d.recipe_name,
                            type_of_recipe : d.type_of_recipe,
                            batch_size : d.batch_size,
                            uom : d.uom,
                            recipe_description : d.description,
                            status : this.$route.query.production && this.$route.query.production == true ? 'production' : d.status,
                            version : this.$route.query.production != true || (this.$route.query.production == true && this.isEdit == true) ? this.version : 1,
                            previous_version : this.isEdit == true ? d.previous_version : this.selectedRecipeId
                        }                        
                        this.data = d.items.map(f => {
                            let d = {};
                            d.item_id = f.recipe_id != null ? f.recipe_id : f.raw_material_id;
                            d.type = f.recipe_id != null ? 'recipe' : 'raw_material';
                            d.unit_price = f.unit_price;
                            d.total = f.total_price;
                            d.uom = f.uom;
                            d.indent = f.qty;    
                            return d;         
                        });
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            async save(){
                try {                    
                    this.form.recipe_id = this.selectedRecipe.id;
                    this.form.batch_size = this.no_of_batches;
                    this.form.status = 'pending';
                    this.form.description = this.description;
                    let res = await axios.post(this.base_url + RG_RECIPE_PATH.SAVE_RECIPE_CARD,this.form);
                    if(res.data.status){
                        Swal.fire("Recipe Created Successfully",'','success');
                        this.downloadInvoiceFile(res.data.data);
                        this.$router.push('/raw_material_to_gravy_recipe_card');
                        return;
                    }
                    throw new Error(res.data.message);
                } catch (error) {
                    console.log(error);
                    Swal.fire("Failed to save",'','error');
                }
            },
            getTotalCost(){                
                return this.data.reduce((a,c) => {return parseFloat(a) + parseFloat(c.total)},0);
            },
            selectedRecipeData(v){
                console.log(v);
                this.selectedRecipe = v;
                this.data = v.items.map(f => {
                                let d = {};
                                d.item_id = f.recipe_id != null ? f.recipe_id : f.raw_material_id;
                                d.type = f.recipe_id != null ? 'recipe' : 'raw_material';                            
                                d.raw_material = f.raw_material;
                                d.recipe = f.recipe;
                                d.uom = f.uom;
                                d.indent = f.qty;    
                                return d;         
                            });
            },
            totalWeight(){
                this.total_weight = this.data.reduce((a,c) => {return a + c.indent},0);
            }
        },
        mounted(){
            
        }
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-row>
            <b-col sm="4">
                <label>Recipe</label>
                <SelectWithSearch :full_object="true" track_by="id" display="recipe_name" :search_api="RG_RECIPE_PATH.SEARCH" :extra_params="'&status=production'" :merge_display="['recipe_name','version']" @selectedOption="selectedRecipeData"></SelectWithSearch>
            </b-col>
            <b-col sm="4">
                <label>Batch Size</label>
                <b-input type="number" v-model="no_of_batches"></b-input>
            </b-col>       
            <b-col sm="4">
                <label>Total Weight</label>
                <p :key="key">{{ (data.reduce((a,c) => {return a + c.indent},0) * no_of_batches) > 1000 ? parseFloat(data.reduce((a,c) => {return a + c.indent},0) * no_of_batches * 0.001).toFixed(2) + ' Kg' : parseFloat(data.reduce((a,c) => {return a + c.indent},0) * no_of_batches).toFixed(2) + ' gm' }}</p>
            </b-col>
            <b-col sm="4" class="mt-2">
                <label>Total Yeild (Cooking Loss : {{ selectedRecipe?.cooking_loss * no_of_batches }} {{ selectedRecipe?.uom }})</label>
                <p :key="key">{{ (data.reduce((a,c) => {return a + c.indent},0) * no_of_batches) > 1000 ? (parseFloat(data.reduce((a,c) => {return a + c.indent},0) * no_of_batches * 0.001).toFixed(2) - (this.selectedRecipe?.uom == 'kg' ? this.selectedRecipe?.cooking_loss * no_of_batches : (this.selectedRecipe?.cooking_loss * no_of_batches * 0.001) ?? 0)) + ' Kg' : (parseFloat(data.reduce((a,c) => {return a + c.indent},0) * no_of_batches).toFixed(2) - (this.selectedRecipe?.uom == 'kg' ? (this.selectedRecipe?.cooking_loss / 1000) * no_of_batches : (this.selectedRecipe?.cooking_loss * no_of_batches) ?? 0)) + ' gm' }}</p>
            </b-col>
        </b-row>
        <b-card>            
            <b-table
            :key="no_of_batches"
            :items="data"
            :fields="fields">                
                <template v-slot:cell(name)="row">                    
                    {{ row.item.type == 'raw_material' ? row.item.raw_material.name : row.item.recipe.recipe_name }}
                </template>
                <template v-slot:cell(uom)="row">
                    {{ row.item.uom }}
                </template>
                <template v-slot:cell(indent)="row">
                    {{ row.item.indent * no_of_batches }}
                </template>
            </b-table>
            <b-button variant="success" style="margin-top: 2%;" @click="save">Save</b-button>
        </b-card>
    </Layout>
</template>

<style>
table.editable-table {
  margin: auto;
  width: auto;
}

table.editable-table td {
  vertical-align: middle;
  padding: 0;
}

.editable-table .data-cell {
  padding: 8px;
  vertical-align: middle;
}

.editable-table .custom-checkbox {
  width: 50px;
}

.name-col {
  width: 120px;
}

.department-col {
  width: 150px;
}

.age-col {
  width: 100px;
}

.date-col {
  width: 200px;
}

.is-active-col {
  width: 100px
}
</style>